/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from '@/lib/api';

// -------- Symptom Checker --------
export const startSymptomSession = (payload) =>
  api.post('/ai/symptom-checker/start', payload).then((r) => r.data);

export const sendSymptomMessage = (session_id, message) =>
  api.post('/ai/symptom-checker/message', { session_id, message }).then((r) => r.data);

export const listSymptomSessions = () =>
  api.get('/ai/symptom-checker/sessions').then((r) => r.data);

export const getSymptomSession = (sid) =>
  api.get(`/ai/symptom-checker/sessions/${sid}`).then((r) => r.data);

// -------- Drug interactions --------
export const checkDrugInteractions = (payload) =>
  api.post('/ai/drug-interactions', payload).then((r) => r.data);

export const listMyDrugChecks = () =>
  api.get('/ai/drug-interactions/mine').then((r) => r.data);

// -------- SOAP Summary --------
export const generateSoapSummary = (payload) =>
  api.post('/ai/soap-summary', payload).then((r) => r.data);

export const getLatestSoapForAppointment = (appointmentId) =>
  api.get(`/ai/soap-summary/appointment/${appointmentId}`).then((r) => r.data);

// -------- No-show Score --------
export const scoreNoShow = (appointmentId) =>
  api.post('/ai/noshow-score', { appointment_id: appointmentId }).then((r) => r.data);

// -------- Doctor Insights --------
export const getDoctorInsights = () =>
  api.get('/ai/insights/doctor').then((r) => r.data);

// -------- ICD-10 --------
export const suggestIcd10 = (clinical_note, appointment_id) =>
  api.post('/ai/icd10-suggest', { clinical_note, appointment_id }).then((r) => r.data);
